import { useState } from 'react';
import { V2SwapHistoryTable } from 'src/components/HistoryTables/V2SwapsHistoryTable';
import V2TradeHistoryTable from 'src/components/HistoryTables/V2TradesHistoryTable';
import PortfolioHistoryTradesTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTradesTable/PortfolioHistoryTradesTableControls';
import { PortfolioHistoryTradesTableType } from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTradesTable/types';

export default function PortfolioHistoryTradesTable() {
	const [tableType, setTableType] =
		useState<PortfolioHistoryTradesTableType>('perps-and-spot');

	return (
		<div>
			<PortfolioHistoryTradesTableControls
				tableType={tableType}
				setTableType={setTableType}
			/>
			{tableType === 'perps-and-spot' && (
				<V2TradeHistoryTable page="portfolio" />
			)}
			{tableType === 'swap' && (
				<V2SwapHistoryTable
					tableContentWrapperClassName="px-0"
					noExpandAllButton
				/>
			)}
		</div>
	);
}
